const UserRole = `
  id
  roleId
  userId
`;

export default UserRole;
